enum BufferTime {
    Time_00 = '0',
    Time_15 = '15',
    Time_30 = '30',
    Time_45 = '45',
    Time_60 = '60'
}

export default BufferTime;
